import { redirect } from "@tanstack/react-router";

import { type Permissions, type Tenant, type User } from "@/types";

export function redirectIfModuleDisabled(
  moduleName: Tenant["modules"][number],
  modules: Tenant["modules"] | undefined,
) {
  if (!modules?.includes(moduleName)) {
    throw redirect({ to: "/" });
  }
}

export class HttpError extends Error {
  public readonly statusCode: number;

  constructor(statusCode: number, message?: string) {
    super(message || `HTTP ${statusCode}`);
    this.name = "HttpError";
    this.statusCode = statusCode;
  }
}

export function throwIfHasNoPermission(
  user: User<true, true> | User<false, true> | undefined,
  permissions: Permissions[] | Permissions,
) {
  permissions = Array.isArray(permissions) ? permissions : [permissions];

  if (
    !user ||
    (!user.is_super_admin &&
      !permissions.some((permission) =>
        (user.permissions || []).includes(permission),
      ))
  ) {
    throw new HttpError(403, "Permission denied");
  }
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError;
}
